import logger from '@/utils/logger';

let hasReportedSuppression = false;

// gloss
// why: guards removeChild/insertBefore against a stale node — without it, browser translate
// why: extensions crash the whole app into the error boundary.
export const installTranslateGuard = (): void => {
  if (typeof window === 'undefined' || typeof Node !== 'function' || !Node.prototype) return;

  const guardedWindow = window as typeof window & { __zealotTranslateGuard?: boolean };
  if (guardedWindow.__zealotTranslateGuard) return;
  guardedWindow.__zealotTranslateGuard = true;

  const reportFirstSuppression = (operation: string): void => {
    if (hasReportedSuppression) return;
    hasReportedSuppression = true;
    logger.warn('Suppressed a DOM mutation on a node detached by a browser translation extension', { operation });
  };

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChild<T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      reportFirstSuppression('removeChild');
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBefore<T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      reportFirstSuppression('insertBefore');
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
};
